import e from"styled-components";const t=e.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 290px;
	background-color: ${({theme:e})=>e.bg.atlassian};
	border-radius: ${({borderRadius:e})=>`${e}px`};
	position: relative;
	padding: 14px;
	overflow: hidden;
`,i=e.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`,o=e.h1`
	margin: 0;
	font-size: 20px;
	color: ${({theme:e})=>e.text.atlassian};
	font-weight: 500;
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
`,a=e.p`
	margin: 0;
	color: ${({theme:e})=>e.text.atlassian50};
	font-size: 14px;
	line-height: 18px;
	white-space: pre-wrap;
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
`,r=e.div`
	position: absolute;
	bottom: 0;
	right: 0;
`,d=e.div`
	z-index: 2;
`,n=e.span`
	background: ${({background:e})=>e};
	color: ${({color:e})=>e};
	border-radius: 9999px;
	padding: 5px 10px;
	font-size: 12px;
	display: inline-block;
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
`,s=e.div`
	position: absolute;
	top: 16px;
	right: 13px;
`;export{s as CardArrowContainer,t as CardContainer,i as CardContentContainer,o as CardHeading,r as CardIllustrationContainer,n as CardLabel,d as CardLabelContainer,a as CardParagraph};
